<ng-container *ngIf="data$ | async as data">
  <div class="course-filter-wrapper">

    <course-filter
      [brandPrimaryColor]="CourseListbrandPrimaryColor"
      [isSwapCardView]="isSwapCardView"
      (swapCard)="swapCardView()"
      (filterPerCategories)="onFilterPerCategoryChanged($event)">
    </course-filter>
  </div>
  <div class="courses-list">
    <div class="row">
      <course-card class="col-12 col-md-6 col-lg-4 card-mode" [brandAccentColor]="CourseListbrandAccentColor" [ngClass]="{ 'list-mode': !isSwapCardView }"
        *ngFor="let course of (filteredCourses?.length ? filteredCourses : courses); let first = first; let last = last" [course]="course" [first]="first"
        [last]="last" (moveDown)="onCourseMovedDown(course)" (moveUp)="onCourseMovedUp(course)"
        [isEditable]="isCourseEditable(data, course)" [isSwapCardView]="isSwapCardView">
      </course-card>
    </div>
  </div>
</ng-container>
